import { render, staticRenderFns } from "./BindZsk.vue?vue&type=template&id=22d20ef8&scoped=true&"
import script from "./BindZsk.vue?vue&type=script&lang=js&"
export * from "./BindZsk.vue?vue&type=script&lang=js&"
import style0 from "./BindZsk.vue?vue&type=style&index=0&id=22d20ef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d20ef8",
  null
  
)

export default component.exports